import {
  canonicalNikkeId,
  fallbackNikkeIdentifier,
  nikkeIdentifierCandidates,
} from '../../nikke-catalog/domain/nikkeCatalog.js';

export function canonicalRaidControlNikkeId(value, catalog) {
  const resolved = canonicalNikkeId(catalog, value);
  if (resolved) return resolved;
  for (const candidate of nikkeIdentifierCandidates(value)) {
    const fallback = fallbackNikkeIdentifier(candidate);
    if (fallback) return fallback;
  }
  return '';
}

export function raidControlDeckCodes(deck = [], catalog) {
  return (Array.isArray(deck) ? deck : [])
    .map((item) => canonicalRaidControlNikkeId(item, catalog))
    .filter(Boolean)
    .slice(0, 5);
}

export function completeRaidControlDeckSignature(deck = [], catalog) {
  const codes = raidControlDeckCodes(deck, catalog);
  return codes.length === 5 ? [...codes].sort().join('|') : '';
}
